var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 26,
    viewBox: "0 0 56 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.336 6.54555C23.1435 6.54555 24.6088 5.08028 24.6088 3.27277C24.6088 1.46527 23.1435 0 21.336 0C19.5285 0 18.0633 1.46527 18.0633 3.27277C18.0633 5.08028 19.5285 6.54555 21.336 6.54555ZM15.4598 15.9843V25.8749H10.632V16.6895C10.632 14.7005 9.38437 13.7602 7.82935 13.7602C6.05735 13.7602 4.82783 14.7909 4.82783 17.0692V25.8568H0V3.32714H4.82783V11.2831C5.69575 10.0897 7.30501 9.31215 9.43864 9.31215C12.6933 9.33023 15.4598 11.6447 15.4598 15.9843ZM23.5966 9.78284H18.7688V25.8936H23.5966V9.78284ZM42.6004 15.9837V25.8744H37.7726V16.6889C37.7726 14.6999 36.525 13.7597 34.97 13.7597C33.198 13.7597 31.9684 14.7903 31.9684 17.0686V25.8563H27.1406V9.74554H31.9684V11.2644C32.8363 10.071 34.4456 9.2935 36.5792 9.2935C39.8339 9.32967 42.6004 11.6441 42.6004 15.9837ZM52.4315 19.8269V14.1312H55.7224V9.50232H52.4135V5L47.5856 6.44653V9.50232H45V14.1312H47.5856V19.8269C47.5856 24.3473 49.43 26.2459 55.7405 25.595V21.2192C53.6249 21.3458 52.4315 21.2192 52.4315 19.8269Z",
    fill: "#066FDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b5dee65e8128320cfbe50b652a5b552a.svg";
export { ForwardRef as ReactComponent };